import React, { useContext } from "react";
import { Link, useParams } from "react-router-dom";
import BottomStickyActions from "../components/BottomStickyActions.js";
import { toast } from "react-toastify";
import mainContext from "../context/mainContext.jsx";
import {
  answerCard,
  handleDeleteCard,
  pickNewCard,
  returnAnswerLevel,
} from "../utils/studyCardUtils.js";
import { answerCardApi, deleteCardApi } from "../services/leitnerApi.js";
import EditCard from "./EditCard.js";
import { checkErrorMessage, checkResponseData } from "../utils/utilsFunctions.js";

export default function Review() {
  const { id } = useParams();
  const [showAnswer, setShowAnswer] = React.useState("hidden");
  const [deleteCardAction, setDeleteCardAction] = React.useState(false);
  const [deleteCardProcess, setDeleteCardProcess] = React.useState(false);
  const [pickedCard, setPickedCard] = React.useState(null);
  const [editCardInfo, setEditCardInfo] = React.useState({ status: false, card: {} });
  const [answerLevel, setAnswerLevel] = React.useState({
    veryHard: 0, hard: 10, medium: 1, easy: 2,
  });
  const { cards, handleCards } = useContext(mainContext);

  const handleEditCardInfo = (data) => setEditCardInfo({ ...editCardInfo, ...data });

  const handleEditCardDone = (editedCard, editedInfo) => {
    let cardLevel;
    let cardGroup = editedCard["learningLevel"];
    const levelMap = { 1: "one", 2: "two", 3: "three", 4: "four", 5: "five", 6: "six", 7: "seven", 8: "eight", 9: "nine", 10: "ten" };
    cardLevel = levelMap[cardGroup] || "one";
    let newAllcards = { ...cards };
    let index;
    newAllcards[cardLevel].forEach((el, idx) => {
      if (editedCard["_id"] === el["_id"]) index = idx;
    });
    let newCardInfo = { ...editedCard, ...editedInfo };
    if (index > -1) newAllcards[cardLevel][index] = newCardInfo;
    setPickedCard(newCardInfo);
    handleCards(newAllcards);
  };

  const deleteCard = async () => {
    setDeleteCardProcess(true);
    try {
      const res = await deleteCardApi({ cardId: pickedCard["_id"] });
      const resData = checkResponseData(res);
      if (res["data"]["success"]) {
        let newAllcards = handleDeleteCard(pickedCard, cards);
        handleCards(newAllcards);
        let getCard = pickNewCard(newAllcards);
        setAnswerLevel(returnAnswerLevel(getCard));
        setPickedCard(getCard);
        toast.success(resData["message"] || "حذف کارت با موفقیت انجام شد");
        setDeleteCardAction(false);
      } else {
        toast.error(resData["message"] || "اتفاق غیر منتظره پیش آمده است");
      }
      setDeleteCardProcess(false);
    } catch (error) {
      setDeleteCardProcess(false);
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      toast.error(errMsg || "مشکلی در حذف کارت وجود دارد");
    }
  };

  const handleaAnswerCard = async (level) => {
    setShowAnswer("saveAnswer");
    const { card, newAllcards } = answerCard(pickedCard, pickedCard["learningLevel"], level, cards);
    handleCards(newAllcards);
    await answerCardApi({ cardId: card["_id"], newLevel: card["learningLevel"] });
    setShowAnswer("hidden");
    let getCard = pickNewCard(newAllcards);
    setAnswerLevel(returnAnswerLevel(getCard));
    setPickedCard(getCard);
  };

  React.useEffect(() => {
    let card = pickNewCard(cards);
    setAnswerLevel(returnAnswerLevel(card));
    setPickedCard(card);
  }, []);

  if (!pickedCard) {
    return (
      <div className="container">
        <div className="card empty">
          <div style={{ fontSize: 32, marginBottom: 12 }}>🎉</div>
          <p style={{ fontWeight: 600 }}>کارت جدیدی برای مرور وجود ندارد</p>
          <Link
            onClick={() => handleCards({ one: [], two: [], three: [], four: [], five: [], six: [], seven: [], eight: [], nine: [] })}
            className="btn success"
            to="/home"
            style={{ textDecoration: "none", marginTop: 12 }}
          >
            برگشت به خانه
          </Link>
        </div>
      </div>
    );
  }

  if (editCardInfo["status"]) {
    return (
      <EditCard
        handleEditCardInfo={handleEditCardInfo}
        editCardInfo={editCardInfo}
        handleEditCardDone={handleEditCardDone}
      />
    );
  }

  return (
    <div className="container" style={{ paddingBottom: 120 }}>
      <div className="card">
        <div className="row" style={{ justifyContent: "space-between" }}>
          <div className="kpis">
            <div className="kpi kpi-green">
              {cards["three"].length + cards["four"].length + cards["five"].length +
               cards["six"].length + cards["seven"].length + cards["eight"].length + cards["nine"].length}
            </div>
            <div className="kpi kpi-amber">{cards["two"].length}</div>
            <div className="kpi kpi-red">{cards["one"].length}</div>
          </div>
          <div className="row" style={{ gap: 8 }}>
            <button className="btn ghost small" onClick={() => handleEditCardInfo({ status: true, card: pickedCard })}>
              ویرایش
            </button>
            <button className="btn danger small" onClick={() => setDeleteCardAction(!deleteCardAction)}>
              حذف
            </button>
          </div>
        </div>
        <div className="review-card-front">{pickedCard.frontCard}</div>
        {showAnswer !== "hidden" && (
          <div className="review-card-back">
            {pickedCard.backCard.map((item, index) => (
              <p key={index} style={{ margin: "4px 0" }}>{item}</p>
            ))}
          </div>
        )}
      </div>
      <BottomStickyActions>
        {deleteCardAction ? (
          deleteCardProcess ? (
            <p className="btn muted" style={{ flex: 1, textAlign: "center" }}>
              در حال حذف ...
            </p>
          ) : (
            <div style={{ width: "100%", textAlign: "center" }}>
              <p style={{ color: "var(--text-secondary)", margin: "0 0 8px", fontSize: 13 }}>
                آیا از حذف این کارت مطمئن هستید؟
              </p>
              <div className="row" style={{ justifyContent: "center" }}>
                <button className="btn ghost" style={{ flex: 1 }} onClick={() => setDeleteCardAction(false)}>
                  انصراف
                </button>
                <button className="btn danger" style={{ flex: 1 }} onClick={deleteCard}>
                  بله، حذف شود
                </button>
              </div>
            </div>
          )
        ) : showAnswer === "hidden" ? (
          <button className="btn" style={{ flex: 1 }} onClick={() => setShowAnswer("show")}>
            نمایش پاسخ
          </button>
        ) : showAnswer === "show" ? (
          <div className="answer-btn-group">
            <button className="btn success" onClick={() => handleaAnswerCard(answerLevel["easy"])}>
              {answerLevel["easy"] === "done" ? (
                "یاد گرفتم"
              ) : (
                <>{answerLevel["easy"]} روز<br />(خیلی آسان)</>
              )}
            </button>
            <button className="btn" style={{ background: "#5f6c80" }} onClick={() => handleaAnswerCard(answerLevel["medium"])}>
              {answerLevel["medium"]} روز<br />(آسان)
            </button>
            <button className="btn muted" onClick={() => handleaAnswerCard(answerLevel["hard"])}>
              {answerLevel["hard"] === 10 ? (
                <>{answerLevel["hard"]} دقیقه<br />(سخت)</>
              ) : (
                <>{answerLevel["hard"]} روز<br />(متوسط)</>
              )}
            </button>
            <button className="btn danger" onClick={() => handleaAnswerCard(answerLevel["veryHard"])}>
              1 دقیقه<br />(مرور مجدد)
            </button>
          </div>
        ) : (
          <p className="btn success" style={{ flex: 1, textAlign: "center" }}>
            در حال ذخیره پاسخ ...
          </p>
        )}
      </BottomStickyActions>
    </div>
  );
}
